import Facade from "@/Facade";
import {Signals} from "@/Imports";

export default new class SoundsHandling {

  constructor() {
    Signals.preloaderAssetsLoadingComplete.add(this.onPreloaderAssetsLoadingComplete, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.muteAll.add(this.muteAll, this)
    Signals.playerTakeWin.add(this.onPlayerParachute, this)

    this.musicVolume = 0.2

    this.hasFocus = true
    this.defaultMute = 1
    this.isMuteSounds = true
    this.isMuteMusic = true
  }

  onPreloaderAssetsLoadingComplete() {
    this.currentMusic = 'gameMainThemeSound'
    this.playMusic()
    this.isMute = false

    setInterval(() => this.checkBrowserOnFocus(), 1000)
  }

  onMakeBets() {
    //Facade.soundManager.play('jet_bets_plz_music')
  }

  onRoundEnd() {

  }

  onContinueBtnClick() {
    Facade.soundManager.play('uiGeneric', this.musicVolume)
  }

  onPlayerParachute() {
    Facade.soundManager.play('uiTake', 0.6)
  }

  playMusic() {
    Facade.soundManager.stop(this.currentMusic)
    Facade.soundManager.play(this.currentMusic, this.musicVolume, true, 'music')
  }


  checkBrowserOnFocus() {
    if (document.hasFocus()) {
      if (!this.hasFocus) {
        if (this.isMuteSounds && !this.isMute) {
          this.muteSounds(1)
        }
        if (this.isMuteMusic && !this.isMute) {
          this.muteMusic(1)
        }
        this.hasFocus = true
      }
    } else {
      if (this.hasFocus) {
        this.muteSounds(0)
        this.muteMusic(0)
        this.hasFocus = false
      }
    }
  }

  muteAll(value) {
    this.isMute = !value
    if (value) {
      this.muteSounds(1)
      this.muteMusic(1)
    } else {
      this.muteSounds(0)
      this.muteMusic(0)
    }
  }

  muteSounds(value) {
    const group = Facade.soundManager.groups['default']
    this.defaultMute = value
    if (value) {
      group.volume = 1
    } else {
      group.volume = 0
    }
  }

  muteMusic(value) {

    const group = Facade.soundManager.groups['music']

    if (!group) return

    if (value) {
      group.volume = 1
    } else {
      group.volume = 0
    }
  }


}
